import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-scroll-search-acte',
  templateUrl: './scroll-search-acte.component.html',
  styleUrls: ['./scroll-search-acte.component.scss']
})
export class ScrollSearchActeComponent implements OnInit {

  items: Array<any> = [];
  user: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  busyGet: Subscription;
  searchKeyActe: any = "";
  acte_id: any
  @Input() garantie_id: any;
  @Input() current_acte_id: any;
  @Input() clearText: any;
  @Output() onSelectActe = new EventEmitter();
  @Input() emmitFull: any;
  @Input() is_garantie_required: boolean;
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.garantie_id && changes.garantie_id.currentValue) {
      this.garantie_id = changes.garantie_id.currentValue;
    }
    if (changes.is_garantie_required && changes.is_garantie_required.currentValue) {
      this.is_garantie_required = changes.is_garantie_required.currentValue;
    }
    if (changes.current_acte_id && changes.current_acte_id.currentValue) {
      this.acte_id = changes.current_acte_id.currentValue;
    }
    if (changes.clearText && changes.clearText.currentValue) {
      this.clearSelection()
    }
    this.itemsPerPage = 10
    this.getItems()
  }
  onSearch(event) {
    console.log("fkdkfjkd", event);
    this.itemsPerPage = 10;
    this.searchKeyActe = event.term;
    if (event.term.length)
      this.getItems();
  }

  clearSelection() {
    this.acte_id = null; // or undefined
    this.items = []
    this.searchKeyActe = ''
  }


  onGetMoreItems() {
    this.itemsPerPage += 5;
    this.getItems();
  }


  onSelectElement() {

    // this.onSelectActe.emit(this.acte_id)
    if (this.emmitFull) {
      let full_benef = this.items.find((it: any) => it.id == this.acte_id)
      this.onSelectActe.emit(full_benef)
    }
    else {
      this.onSelectActe.emit(this.acte_id)

    }

  }

  getItems() {
    if(this.is_garantie_required && !this.garantie_id)return
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: this.itemsPerPage,
      search_key: this.searchKeyActe,
      data: {
        // reseau_de_soin_id: this.reseau_de_soin_id,
        garantie_id: this.garantie_id,
      },
    };

    this.busyGet = this.restClient
      .post("acte/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.items = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.items = [];
          }
        },
        (err) => {
          this.items = [];
        }
      );
  }

  onSelectTypePrestataire() { }

  ngOnInit() {
  }

}
